import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/about_watame.png'
import _imports_1 from '@/assets/img/vsinger_watame01.png'


const _withScopeId = n => (_pushScopeId("data-v-f138b748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-owner-area" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"two-column-row\" data-v-f138b748></div><div class=\"two-column-row\" data-v-f138b748><div class=\"column\" data-v-f138b748><img src=\"" + _imports_0 + "\" alt=\"\" data-v-f138b748></div><div class=\"column\" data-v-f138b748><div class=\"text-area\" data-v-f138b748><h3 data-v-f138b748>VTuberとして</h3><div class=\"description\" data-v-f138b748><h4 data-v-f138b748>角巻わため</h4> ホロライブ所属2019/12/29にデビューした歌うことが大好きな吟遊詩人の羊。歌枠・ゲーム実況・雑談配信を高頻度で行っている。わためいと（リスナー）とコメント欄で会話をするのが好きでアーカイブ時間が長時間になりがち。<br data-v-f138b748><div class=\"social-links\" data-v-f138b748><a href=\"https://hololive.hololivepro.com/talents/tsunomaki-watame/\" target=\"_blank\" data-v-f138b748><i class=\"fa fa-link\" data-v-f138b748></i></a><a href=\"https://www.youtube.com/channel/UCqm3BQLlJfvkTsX_hvm0UmA\" target=\"_blank\" data-v-f138b748><i class=\"fab fa-youtube\" data-v-f138b748></i></a><a href=\"https://twitter.com/tsunomakiwatame\" target=\"_blank\" data-v-f138b748><i class=\"fab fa-twitter\" data-v-f138b748></i></a></div></div></div></div></div>", 2)
const _hoisted_4 = { class: "two-column-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { class: "text-area" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "VSingerとして", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createTextVNode(" デビュー当初から歌動画（ "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.youtube.com/playlist?list=PLZ34fLWik_iB_cdmHivl8xhMJW6JwIkNn",
    target: "_blank"
  }, "わためのうた"),
  /*#__PURE__*/_createTextVNode("）や定期カラオケ配信である"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.youtube.com/playlist?list=PLZ34fLWik_iB5_4d8q_e4ix_C1FKd5F5R",
    target: "_blank"
  }, "わためぇ Night Fever!!"),
  /*#__PURE__*/_createTextVNode("など特に音楽活動を精力的に行っている。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" フルサイズのオリジナル曲は15曲以上、歌ってみた動画はコラボも含め20曲以上あり、最近は外部のライブイベントにもVSingerとして出演することも増えている。 また、2021/10/12には自身初となる有観客ソロライブ "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://watame1stlive.hololive.tv/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "角巻わため 1st Live「わためぇ Night Fever!! in Zepp Tokyo」")
  ]),
  /*#__PURE__*/_createTextVNode(" を開催した。 ")
], -1))
const _hoisted_10 = { class: "see-more-music" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "音楽活動について", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeneralTitle = _resolveComponent("GeneralTitle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SimpleLinkCarousel = _resolveComponent("SimpleLinkCarousel")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_GeneralTitle, {
      title: "About Owner",
      id: "owner"
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "fas fa-angle-double-right fa-pull-left",
              to: "music"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_SimpleLinkCarousel, {
      title: "",
      contents: _ctx.state.originalSongs,
      navigation: false,
      pagination: false
    }, null, 8, ["contents"])
  ]))
}